import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormGroup} from "@angular/forms";
import {SharedDataService} from "../../../services/shared-data.service";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-package-config-popup',
  templateUrl: './package-config-popup.component.html',
  styleUrls: ['./package-config-popup.component.css']
})
export class PackageConfigPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  packages: object[];
  packageGroups: string[] = [];
  packagesGrouped: object[][] = [];
  state: string = 'default';
  mode: string;
  errMsg: string = '';

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) { }

  ngOnInit(): void {
  }

  public onNoClick(): void {
    this.close.emit()
  }

}
